export const checkTitleExists = ({ nodes, title }) => {
    const defaultValues = ["start point", "default fallback"]

    if(defaultValues.includes(title)){
        return true
    }
    const titleExists = nodes.find((node) => node?.title?.toLowerCase() === title.toLowerCase())
    return titleExists ? true : false
}